import { createContext, useContext } from 'react';

export const TaskSummaryContext = createContext();

export const useTaskSummaryContext = () => useContext(TaskSummaryContext);

export default TaskSummaryContext;
